import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';

import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			selectedImageIndex: undefined,
			openstreetmap: false,
			units: [],
			imagesForModal: []
		};
	},
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}

		var facilityid;
		let el = document.querySelector("[data-facilityid]");
		if (el) {
			facilityid = parseInt(el.getAttribute('data-facilityid'), 10);
		} else {
			console.log('element facilityid is not found..................');
		}
		/*console.log('facilityid:::' + facilityid);
		if (facilityid) {
			if (facilityid == 182614) {
				unitgroupid = 45082;
			} else if (facilityid == 182613) {
				unitgroupid = 45081;
			} else if (facilityid == 182616) {
				unitgroupid = 45080;
			} else if (facilityid == 182617) {
				unitgroupid = 45079;
			} else if (facilityid == 182647) {
				unitgroupid = 45078;
			} else if (facilityid == 182623) {
				unitgroupid = 45076;
			} else if (facilityid == 182622) {
				unitgroupid = 45071;
			} else if (facilityid == 182646) {
				unitgroupid = 45070;
			} else if (facilityid == 182644) {
				unitgroupid = 45066;
			} else if (facilityid == 182640) {
				unitgroupid = 45065;
			} else if (facilityid == 182618) {
				unitgroupid = 45064;
			} else if (facilityid == 182637) {
				unitgroupid = 45063;
			} else if (facilityid == 182632) {
				unitgroupid = 45062;
			} else if (facilityid == 182620) {
				unitgroupid = 45061;
			} else if (facilityid == 182625) {
				unitgroupid = 45060;
			} else if (facilityid == 182627) {
				unitgroupid = 45058;
			} else if (facilityid == 182627) {
				unitgroupid = 45058;
			} else if (facilityid == 182641) {
				unitgroupid = 45085;
			}
		}
		console.log('unitgroupid:::' + unitgroupid);*/
		var req = {
			fields: this.resultFields,
			filter: {
				unitgroupid: facilityid
			},
			sorting: 'random',
			pricelist: true,
			max: 150
		};

		doReq('searchUnits', req)
			.then((res) => {
				this.units = res.units;

			});

	},

	created() {
		window.addEventListener("resize", this.myEventHandler);
	},
	destroyed() {
		window.removeEventListener("resize", this.myEventHandler);
	},

	updated: function () {
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();


	},
	methods: {
		showImagesModal: function (images, uniqueId = '') {
			if (images && images.length > 1) {
				this.imagesForModal = images;
				//$('#unitImages').modal('show');
				this.showCustomModal('unitImages' + uniqueId);

			} else {
				this.imagesForModal = [];
			}
		},
		showCustomModal: function (id) {
			let wh = window.innerHeight;

			// Get the modal
			const modal = document.getElementById(id);

			if (modal) {
				var dialog = modal.getElementsByClassName("modal-custom-dialog")[0];
				var content = modal.getElementsByClassName("modal-custom-content")[0];

				if (dialog && content) {
					dialog.style.height = wh - 40 + "px";
					content.style.height = wh - 120 + "px";

					modal.style.display = "block";

					// When the user clicks anywhere outside of the modal, close it
					window.onclick = function (event) {
						if (event.target == modal) {
							modal.style.display = "none";
						}
					};
				}
			}
		},

		closeCustomModal: function (id) {
			const modal = document.getElementById(id);
			if (modal) {
				modal.style.display = "none";
			}

		},
		getUnitSearchTarget: function (id) {
			return 'unit_' + id;
		},

	}

};